import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { AuthService as Auth0Service } from "@auth0/auth0-angular";
import { Observable, combineLatest, of } from "rxjs";
import { map, take, tap } from "rxjs/operators";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class LoginGuard implements CanActivate {
  constructor(
    private service: AuthService,
    private auth0: Auth0Service
  ) { }

  canActivate(): Observable<boolean> {
    return combineLatest([
      this.auth0.isAuthenticated$,
      of(this.service.isAuthenticated),
    ]).pipe(
      take(1),
      map(([auth0, auth]) => auth0 || auth),
      tap(isAuth => {
        if (!isAuth) {
          this.service.logout();
        }
      })
    );
  }

}
